import { Ajv2020, type ErrorObject, type ValidateFunction } from "ajv/dist/2020.js";
import addFormats from "ajv-formats";
import { defForMessageType, schemaDocument } from "./contract.ts";

const schema = schemaDocument();

const ajv = new Ajv2020({
  allErrors: true,
  strict: true,
  strictRequired: false,
  strictTypes: false,
});
const formatPlugin: unknown = addFormats;
if (typeof formatPlugin !== "function") {
  throw new Error("ajv-formats did not export a function");
}
formatPlugin.call(undefined, ajv);
ajv.addKeyword({ keyword: "x-signalr" });
ajv.addKeyword({ keyword: "x-dataChannels" });
ajv.addSchema(schema);

const validators = new Map<string, ValidateFunction>();

function validatorFor(defName: string): ValidateFunction {
  const cached = validators.get(defName);
  if (cached) return cached;
  const compiled = ajv.getSchema(`${schema.$id}#/$defs/${defName}`);
  if (!compiled) {
    throw new Error(`unknown schema def ${defName}`);
  }
  validators.set(defName, compiled);
  return compiled;
}

export function formatSchemaErrors(errors: ErrorObject[] | null | undefined): string[] {
  if (!errors || errors.length === 0) return ["schema validation failed"];
  return errors.map((error) => {
    const path = error.instancePath || "/";
    return `${path} ${error.message ?? error.keyword}`;
  });
}

export function validateMessageType(type: string, value: unknown): { ok: true } | { ok: false; errors: string[] } {
  const defName = defForMessageType(type);
  if (!defName) return { ok: false, errors: [`unknown message type ${type}`] };
  const validate = validatorFor(defName);
  if (validate(value)) return { ok: true };
  return { ok: false, errors: formatSchemaErrors(validate.errors) };
}
